export enum ScreenSize {
  SM = 320,
  MD = 768,
  LG = 1400,
}

export const breakpoints = {
  smallOnly: `(max-width: ${ScreenSize.MD / 16}em)`,
  extraSmall: `(max-width: ${ScreenSize.SM / 16}em)`,
  small: `(min-width: ${ScreenSize.SM / 16}em)`,
  medium: `(min-width: ${ScreenSize.MD / 16}em)`,
  large: `(min-width: ${ScreenSize.LG / 16}em)`,
  ltLarge: `(max-width: ${ScreenSize.LG / 16}em)`,
} as const

type Breakpoints = typeof breakpoints
type MQ = { [K in keyof Breakpoints]: string }

export const mq: MQ = Object.fromEntries(
  Object.entries(breakpoints).map(([bp, value]) => [bp, `@media ${value}`])
) as MQ
